import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../components/helper";

export const fetchOrderedItems = createAsyncThunk(
  "orderedItems/fetchOrderedItems",
  async (payload) => {
    const response = await http.post("previouspurchases", payload);
    return response.data;
  },
);

const initialState = {
  items: [],
  categories: [],
  totalRecords: 0,
  favouriteItems: 0,
  status: "idle",
  error: null,
  categoriesStatus: "idle",
  filtersStatus: "idle",
};

const orderedItemsSlice = createSlice({
  name: "orderedItems",
  initialState,
  reducers: {
    resetOrderedItems(state) {
      state.items = [];
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderedItems.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOrderedItems.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload.data || [];
        state.totalRecords = action.payload.totalRecords || 0;
        state.favouriteItems = action.payload.favouriteItems || 0;
      })
      .addCase(fetchOrderedItems.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { resetOrderedItems } = orderedItemsSlice.actions;
export default orderedItemsSlice.reducer;
